"use client";

import { useEffect } from "react";
import posthog from "posthog-js";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log unexpected errors automatically to PostHog
    posthog.capture("$exception", {
      $exception_message: error.message,
      $exception_name: error.name,
      $exception_stack: error.stack,
      $exception_digest: error.digest,
    });
    console.error(error);
  }, [error]);

  return (
    <div className="flex h-[80vh] w-full flex-col items-center justify-center p-4 text-center">
      <h2 className="mb-4 text-2xl font-bold tracking-tight">
        Something went wrong!
      </h2>
      <p className="mb-6 text-muted-foreground max-w-[500px]">
        We&rsquo;ve captured the error and our team will look into it. Please
        try again.
      </p>
      <button
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        onClick={() => reset()}
      >
        Try again
      </button>
    </div>
  );
}
